/* eslint-disable */
import React from "react";
import GaugeChart from "./GaugeChart";
import DonutTile from "./GaugeChart";

const GaugeTileCard = ({ title, timeliness, accuracy, color1, color2 }) => {
  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "10px",
        padding: "15px",
        backgroundColor: "rgb(226 243 255)",
        width: "100%",
        // maxWidth: "350px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
      }}
    >
      <p
        style={{
          fontWeight: "800",
          fontSize: "14px",
          marginBottom: "10px",
        }}
      >
        {title}
      </p>

      <div className="row"
        // style={{
        //   display: "flex",
        //   justifyContent: "space-around",
        // }}
      >
        <div className="col-lg-6 col-sm-12 col-12 mb-1" style={{ textAlign: "center" }}>
          <DonutTile title={"Timeliness"} dataValue={timeliness} remainingValue={
        100 - timeliness}/>
        </div>

        <div className="col-lg-6 col-sm-12 col-12" style={{ textAlign: "center" }}>
          <DonutTile title={"Accuracy"} dataValue={accuracy} remainingValue={
        100 - accuracy}/>
        </div>
      </div>
    </div>
  );
};

export default GaugeTileCard;